import React, { useState } from 'react';
import { Container, Col, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';
import './login-screen.css';
import Logo from '../../assets/images/logo-bullcapital-2x.png';
import { setTokens } from '../../utils/auth.utils';

const LoginScreen: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await api.post('/auth/admins/login', { username, password });
      setTokens(response);
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Error en login:', err);

      // Extract specific error message from the API response
      let errorMessage = 'Usuario o contraseña incorrectos';

      if (err?.response?.data?.error?.message) {
        errorMessage = err.response.data.error.message;
      } else if (err?.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    }
  };

  return (
    <Container fluid className="vh-100 login-container">
      <Col md={6} className="d-flex justify-content-center align-items-center">
        <img src={Logo} alt="Bell Capital MX" className="logo" style={{ maxWidth: '50%' }} />
      </Col>
      <Col
        md={6}
        className="d-flex flex-column justify-content-center align-items-center login-left text-white login-form"
      >
        <h2>Iniciar Sesión</h2>
        <Form className="w-50" onSubmit={handleLogin}>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group controlId="username" className="mb-3">
            <Form.Label>Usuario</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingresa tu usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="password" className="mb-3">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control
              type="password"
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button variant="warning" type="submit" className="w-100">
            Ingresar
          </Button>
        </Form>
      </Col>
    </Container>
  );
};

export default LoginScreen;
